export default "__VITE_ASSET__a9e037c0__"